import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AddRecruitModal from '../Modals/AddRecruitModal'; // adjust the import path as necessary

const AddRecruitButton = ({ addRecruit }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  
  // Only show button on /hr and /analytics routes
  const isVisiblePath = location.pathname === '/hr' || location.pathname === '/analytics';
  
  // If not on a visible path, don't render anything
  if (!isVisiblePath) {
    return null;
  }
  
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  return (
    <>
      <button
        onClick={openModal}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          h-[50px] cursor-pointer border-none 
          inline-flex items-center justify-center
          transition-all duration-300
        `}
        style={{ 
          borderRadius: '25px',
          backgroundColor: '#0832DE',
          width: '200px',
          boxShadow: isHovered ? '0px 4px 8px rgba(8, 50, 222, 0.3)' : 'none',
          transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        }}
      >
        <div className="flex items-center justify-center gap-2 text-white">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7V17.4C1 17.9601 1 18.2399 1.10899 18.4538C1.20487 18.642 1.35774 18.7952 1.5459 18.8911C1.7596 19 2.0395 19 2.59846 19H13.0001M12 11V8M12 8V5M12 8H9M12 8H15M5 11.8002V4.2002C5 3.08009 5 2.51962 5.21799 2.0918C5.40973 1.71547 5.71547 1.40973 6.0918 1.21799C6.51962 1 7.08009 1 8.2002 1H15.8002C16.9203 1 17.4801 1 17.9079 1.21799C18.2842 1.40973 18.5905 1.71547 18.7822 2.0918C19.0002 2.51962 19.0002 3.07969 19.0002 4.19978V11.7998C19.0002 12.9199 19.0002 13.48 18.7822 13.9078C18.5905 14.2841 18.2842 14.5905 17.9079 14.7822C17.4805 15 16.9215 15 15.8036 15H8.1969C7.07899 15 6.5192 15 6.0918 14.7822C5.71547 14.5905 5.40973 14.2842 5.21799 13.9079C5 13.4801 5 12.9203 5 11.8002Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-base font-medium">Добавить запись</span>
        </div>
      </button>
      
      {/* Modal */}
      <AddRecruitModal
        isOpen={isModalOpen}
        onClose={closeModal}
        addRecruit={addRecruit}
      />
    </>
  );
};

export default AddRecruitButton;
